import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Observable } from 'rxjs';

// Services
import { NetworkService } from '../../services/network/network.service';
import { LoggerService } from '../../services/logger/logger.service';

export const ConnectionGuard: CanActivateFn = () => {
  const networkService = inject(NetworkService);
  const logger = inject(LoggerService);

  return new Observable((observer) => {
    logger.consoleLog('ConnectionGuard', 'CanActivateFn', 'networkService.appStarted');
    networkService.appStarted();

    observer.next(true);
  });
};
